
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                ECOMODE STUDIO
              </h3>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Protecting your digital privacy with advanced VPN technology and innovative security solutions.
            </p>
          </div>

          <div>
            <h6 className="text-lg font-bold mb-4">Quick Links</h6>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h6 className="text-lg font-bold mb-4">Contact Info</h6>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                <span className="text-gray-400">
                  SAVE TEKELIJE 56, Kikinda<br />371174, Serbia
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-blue-400"></i>
                <a href="mailto:information@ecomodestudiodoo.com" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  information@ecomodestudiodoo.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-blue-400"></i>
                <a href="tel:+13853881128" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  +1 385 388 1128
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} ECOMODE STUDIO DOO. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
